import numeral from "numeral";

export default v => (v < 0 ? "0.00%" : numeral(v).format("0[.]00%"));
